
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/detalii-livrare",
      function () {
        return require("private-next-pages/info/detalii-livrare.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/detalii-livrare"])
      });
    }
  